export default "__VITE_ASSET__C6hCsl9n__"